<template>
    <div class="overlay_comp_wrap" v-if="isShow" v-clickoutside:action_Hide="">
            <div v-if="isLoading" class="loading_bg" style="z-index: 999;">
                <div class="loading_wrap">
                    <div class="loading_obj">
                        <svg class="spinner" width="60px" height="60px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                        </svg>
                    </div>
                </div>
            </div>
            <div class="overlay_comp_title">고객 태그<a class="mgl_auto" @click="action_Hide()"><v-icon>mdi-close</v-icon></a></div>
            <div class="overlay_comp_desc">
                <v-icon>mdi-alert-circle-outline</v-icon>
                <div>고객 태그는 [병원 설정] > [태그 관리]에서 추가/삭제할 수 있습니다.</div>
            </div>
            <div class="overlay_comp_desc">
                <input type="text" class="input_s w_full" v-model="keyword" placeholder="태그 검색" @keydown.enter="loadTag">
            </div>
            <div class="overlay_comp_cont">
                <ul class="overlay_comp_list">
                    <li v-for="d in data" :key="d._id">
                        <label class="check_wrap w_full"><input type="checkbox" v-model="d.isSelected"><span class="checkmark"></span> {{d.name}}</label>
                    </li>
                </ul>
            </div>
            <div class="overlay_comp_bottom">
                <button class="btn btn_s w_full btn_blue" @click="action_Update">변경</button>
            </div>
    </div>
</template>


<script>
const moment = require('../../../../../util/MPMoment')
import { mapState } from 'vuex'
import { useQueryClient } from '@tanstack/vue-query'
import { userTagFindQueryOptions } from '@/composables/queries/usertag/use-usertag-find-query'
import { useHServiceUpdateMutation } from '@/composables/queries/hservice/use-hservice-update-mutation'
import { isApiErrorWithCode } from '@/apis/instances/check-api-response'
export default {
    setup() {
        const queryClient = useQueryClient()
        const { mutateAsync: mutateHService } = useHServiceUpdateMutation()
        return { queryClient, mutateHService }
    },
    props: {
        isShow: Boolean,
        selectedService: Object
    },
    data() {
        return {
            data: [],
            keyword: '',

            isLoading: true,
        }
    },
    computed: {
        ...mapState(['hospital']),
    },
    watch: {
        isShow: function(newValue) {
            if (newValue == true) {
                this.keyword = ''
                this.loadTag()
            }
        }
    },
    methods: {
        async loadTag() {
            this.isLoading = true
            let hospitalID = this.hospital.selectedHospital._id
            let model = {
                hospitalID: hospitalID,
                isRemoved: false
            }
            if (this.keyword != undefined || this.keyword != '') {
                model.keyword = this.keyword
            }
            let fetchedTags
            try {
                fetchedTags = await this.queryClient.fetchQuery(userTagFindQueryOptions(model))
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남기고 중단
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
                this.isLoading = false
                return
            }
            // 캐시 공유 객체에 isSelected 를 직접 심지 않도록 복사 후 작업
            const tags = fetchedTags.map(t => ({ ...t, isSelected: false }))
            for (let i=0 ; i<tags.length ; i++) {
                let t = tags[i]
                for (let ti=0 ; ti<this.selectedService.userTagIDs.length ; ti++) {
                    let st = this.selectedService.userTagIDs[ti]
                    if (t._id == st._id) {
                        tags[i].isSelected = true
                    }
                }
            }
            this.isLoading = false
            this.data = tags
        },

        async action_Update() {
            this.isLoading = true
            let selectedTags = []
            for (let i=0 ; i<this.data.length ; i++) {
                let d = this.data[i]
                if (d.isSelected == true) {
                    selectedTags.push(d._id)
                }
            }

            try {
                await this.mutateHService({
                    hserviceID: this.selectedService._id,
                    userTagIDs: selectedTags
                })
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남기고 중단
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
                this.isLoading = false
                return
            }
            
            this.AC_UpdatePushNotificationValue({
                key: 'd_HServiceUpdate_el',
                value: {
                    createdAt: moment()
                }
            })
            this.isLoading = false
            this.action_Hide(true)
        },
        action_Hide(isUpdated = false) {
            if (this.isLoading == true) { return }
            this.$emit('action_HideTag', isUpdated)
        }
    }
}
</script>


<style scoped>

</style>